var DiagonalMovement = {
    Always: 1,
    Never: 2,
    IfAtMostOneObstacle: 3,
    OnlyWhenNoObstacles: 4
};

module.exports = DiagonalMovement;


//////////////////
// WEBPACK FOOTER
// /home/giant/builds/t1_QpaSbS/0/vivesa/mcepharma.com/~/pathfinding/src/core/DiagonalMovement.js
// module id = 2
// module chunks = 0